import { http } from 'vue'

export default {
  // load client from the API server
  loadClient (context, params = {}) {
    const withParam = params.with ? '&with=' + params.with : ''
    return http.get('clients' + '?user_id=' + params.userId + withParam)
  },
  // create client at the API server
  postClient (context, params = {}) {
    return http.post('clients', params.data)
  },
  // edit client at the API server
  putClient (context, params = {}) {
    return http.put('clients/' + params.id, params.data)
  },
  // load client details from the API server
  loadClientDetails (context, params = {}) {
    return http.get('clients/' + params.clientId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/actions.js